import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-01/lesson-26/task-02";

const task: Slide = {
  titleHtml:
    "Consider a spherical wave which propagates in a medium in which the absorption<br>coefficient is 0.01 m<sup>-1</sup> (0.1 dB/m). The amplitude at 1 m from the source is 1 Pa.<br>Calculate the amplitude and the attenuation in dB (relative to the level at 1 m) at a<br>distance from the source of 10 m, 100 m, and 1000 m, with and without absorption.<br>The amplitude of the spherical wave at 100 m from the source is:",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
